import { Component, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Observable } from 'rxjs/observable';

import { Meetup } from '../../models/meetup';
import { MeetupService } from '../../services/meetup.service';
import { AddMeetupComponent } from '../add-meetup/add-meetup.component';
import { UpdateMeetupComponent } from '../update-meetup/update-meetup.component';
import { AssignMembersComponent } from '../assign-members/assign-members.component';

@Component({
	selector: 'app-meetups',
	templateUrl: './meetups.component.html',
	styleUrls: ['./meetups.component.scss']
})
export class MeetupsComponent implements OnInit {
	public meetups: Observable<Meetup[]>;

	constructor(private dialog: MdDialog,
							private meetupService: MeetupService) {
		this.meetups = meetupService.getMeetups();
	}

	ngOnInit() { }

	public add(): void {
		let dialogRef = this.dialog.open(AddMeetupComponent, {
			width: '300px'
		});
	}

	public update(meetup: Meetup): void {
		let dialogRef = this.dialog.open(UpdateMeetupComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(meetup);
	}

	public assignMembers(meetup: Meetup): void {
		let dialogRef = this.dialog.open(AssignMembersComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(meetup);
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/meetups/meetups.component.ts